export default {"src":"/_next/static/media/ping-ping.af8592a9.svg","height":192,"width":192};